exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2a7HnftQ{display:-webkit-box;display:-ms-flexbox;display:flex;padding:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._13xDb1AQ{line-height:1;padding:10px;color:#ff8000;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._2ZVWUOgw{font-size:36px}._21Ah4mto{font-weight:400;height:24px;margin-left:10px}._32H_SIhU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"component": "_2a7HnftQ",
	"icon": "_13xDb1AQ",
	"icon__icon": "_2ZVWUOgw",
	"description": "_21Ah4mto",
	"content": "_32H_SIhU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/errorControl/style.less
// module id = 1272
// module chunks = 1